import { z } from 'zod';
export var PeakMethod = z.enum([
    'gun',
    'poison',
    'drugs',
    'prescriptions',
    'suffocation',
    'hanging',
    'cutting',
    'other'
]);
/**
 * Stores a single warning sign
 */ export var CrisisTimelineEvent = z.object({
    ID: z.string().prefault(''),
    isWarningSign: z.boolean().prefault(false),
    text: z.string().prefault(''),
    // To support AVIVA_MILITARY variant, we need to know what section of the suicide mode the item comes from
    suicideModeSection: z.enum([
        'afterEvents',
        'beforeEvents',
        'feelings',
        'thoughts',
        'behaviors',
        'physiological'
    ]).optional(),
    peakMethods: z.array(PeakMethod).optional()
}).describe('Stores a single warning sign');
/**
 * A patient crisis timeline
 */ export var CrisisTimeline = z.object({
    crisisPeakID: z.string().prefault(''),
    /**
     * A patient crisis timeline sequence
     */ timeline: z.array(CrisisTimelineEvent).prefault([])
}).prefault({
    crisisPeakID: '',
    timeline: []
}).describe('A patient crisis timeline');
